import {
  UPSERT_VECTORS_ROUTE,
  CREATE_INDEX_ROUTE,
  QUERY_VECTORS_ROUTE,
  LIST_INDEXES_ROUTE,
  DESCRIBE_INDEX_ROUTE,
  DELETE_INDEX_ROUTE,
  LIST_VECTORS_ROUTE,
  LIST_EMBEDDERS_ROUTE,
} from '../../handlers/vector';

export const VECTORS_ROUTES = [
  UPSERT_VECTORS_ROUTE,
  CREATE_INDEX_ROUTE,
  QUERY_VECTORS_ROUTE,
  LIST_INDEXES_ROUTE,
  DESCRIBE_INDEX_ROUTE,
  DELETE_INDEX_ROUTE,
  LIST_VECTORS_ROUTE,
  LIST_EMBEDDERS_ROUTE,
] as const;
